document.addEventListener("DOMContentLoaded", function () {
  const menu = document.getElementById("p80-mobile-menu");
  const overlay = document.getElementById("p80-mobile-menu-overlay");
  const openBtn = document.getElementById("open-mobile-menu");
  const closeBtn = document.getElementById("close-mobile-menu");
  let panelsWrapper;

  function initMenu() {
    const template = document.getElementById("menu-content-template");
    if (!template) return;

    panelsWrapper = document.createElement("div");
    panelsWrapper.className = "p80-mm__panels";

    menu.appendChild(panelsWrapper);

    // Create the root panel that will hold the combined menu content
    const rootMenu = document.createElement("ul");
    rootMenu.id = "p80-mm-panel-0";
    rootMenu.classList.add("is-active");

    // Get all top-level elements from the template
    const menuContent = template.content.cloneNode(true);
    const templateNodes = Array.from(menuContent.childNodes);

    let isFirstList = true;
    templateNodes.forEach((node) => {
      // Node.ELEMENT_NODE is 1, Node.TEXT_NODE is 3. We only want elements.
      if (node.nodeType !== 1) return;

      if (node.tagName === "H4") {
        const headingLi = document.createElement("li");
        headingLi.className = "p80-mm__heading";
        headingLi.appendChild(node);
        rootMenu.appendChild(headingLi);
      }

      if (node.tagName === "UL") {
        const sourceClass = node.className;
        let itemModifierClass = "";
        if (sourceClass.includes("p80-mm__main-menu")) {
          itemModifierClass = "p80-mm__item--main";
        } else if (sourceClass.includes("p80-mm__secondary-menu")) {
          itemModifierClass = "p80-mm__item--secondary";
        } else if (sourceClass.includes("p80-mm__tertiary-menu")) {
          itemModifierClass = "p80-mm__item--tertiary";
        }

        if (!isFirstList) {
          const dividerLi = document.createElement("li");
          dividerLi.className = "p80-mm__divider";
          rootMenu.appendChild(dividerLi);
        }
        // Move all list items from the template's UL to the rootMenu UL
        while (node.firstElementChild) {
          const li = node.firstElementChild;
          if (itemModifierClass) {
            li.classList.add(itemModifierClass);
            // Add the class to all children as well
            li.querySelectorAll("li").forEach((childLi) => {
              childLi.classList.add(itemModifierClass);
            });
          }
          rootMenu.appendChild(li);
        }
        isFirstList = false;
      }
    });

    panelsWrapper.appendChild(rootMenu);

    let panelIdCounter = 0;

    function processLevel(ulElement, level) {
      const listItems = ulElement.querySelectorAll(":scope > li");
      listItems.forEach((item) => {
        const submenu = item.querySelector(":scope > ul");
        const link = item.querySelector(":scope > a");

        // Skip items that are not menu items (like headings or dividers)
        if (!link) return;

        // Add level class to all list items
        item.classList.add(`level-${level}`);

        if (submenu) {
          item.classList.add("has-submenu");

          if (item.classList.contains("p80-mm__custom")) {
            // specific for 'Find a Store' menu item
          } else if (level < 3) {
            panelIdCounter++;
            const panelId = `p80-mm-panel-${panelIdCounter}`;
            submenu.id = panelId;
            panelsWrapper.appendChild(submenu);

            const linkHTML = link.innerHTML;
            item.removeChild(link);

            const nextBtn = document.createElement("button");
            nextBtn.className = "p80-mm__next";
            nextBtn.innerHTML = linkHTML;
            nextBtn.setAttribute("tabindex", "-1");
            nextBtn.dataset.target = panelId;
            nextBtn.type = "button";
            item.appendChild(nextBtn);

            const backLi = document.createElement("li");
            const backBtn = document.createElement("button");
            backBtn.className = "p80-mm__back";
            backBtn.innerHTML = linkHTML;
            backBtn.setAttribute("tabindex", "-1");
            backBtn.dataset.parent = ulElement.id;
            backBtn.type = "button";
            backLi.appendChild(backBtn);
            submenu.insertBefore(backLi, submenu.firstChild);

            processLevel(submenu, level + 1);
          } else {
            const linkHTML = link.innerHTML;
            item.removeChild(link);

            const toggleBtn = document.createElement("button");
            toggleBtn.className = "p80-mm__toggle";
            toggleBtn.type = "button";
            toggleBtn.innerHTML = linkHTML;
            item.prepend(toggleBtn);
          }
        }
      });
    }

    processLevel(rootMenu, 1);
  }

  function openMenu() {
    menu.classList.add("is-open");
    overlay.classList.add("is-visible");
    document.body.classList.add("p80-mm-open");
    menu.querySelectorAll("a").forEach((elem) => {
      elem.removeAttribute("tabindex");
    });
    menu.querySelectorAll(".p80-mm__next").forEach((elem) => {
      elem.removeAttribute("tabindex");
    });
    menu.querySelectorAll(".p80-mm__back").forEach((elem) => {
      elem.removeAttribute("tabindex");
    });
    menu.querySelectorAll(".p80-mm__toggle").forEach((elem) => {
      elem.removeAttribute("tabindex");
    });
  }

  function closeMenu() {
    menu.classList.remove("is-open");
    overlay.classList.remove("is-visible");
    document.body.classList.remove("p80-mm-open");

    menu.querySelectorAll("a").forEach((elem) => {
      elem.setAttribute("tabindex", "-1");
    });
    menu.querySelectorAll(".p80-mm__next").forEach((elem) => {
      elem.setAttribute("tabindex", "-1");
    });
    menu.querySelectorAll(".p80-mm__back").forEach((elem) => {
      elem.setAttribute("tabindex", "-1");
    });
    menu.querySelectorAll(".p80-mm__toggle").forEach((elem) => {
      elem.setAttribute("tabindex", "-1");
    });

    setTimeout(() => {
      if (!menu.classList.contains("is-open") && panelsWrapper) {
        panelsWrapper
          .querySelectorAll("ul")
          .forEach((panel) => panel.classList.remove("is-active", "is-parent"));
        const rootPanel = panelsWrapper.querySelector("#p80-mm-panel-0");
        if (rootPanel) rootPanel.classList.add("is-active");
        panelsWrapper
          .querySelectorAll("li.is-active")
          .forEach((item) => item.classList.remove("is-active"));
      }
    }, 300);
  }

  openBtn.addEventListener("click", openMenu);
  closeBtn.addEventListener("click", closeMenu);
  overlay.addEventListener("click", closeMenu);

  menu.addEventListener("click", function (e) {
    const target = e.target.closest(
      ".p80-mm__close, .p80-mm__next, .p80-mm__back, .p80-mm__toggle"
    );
    if (!target || !panelsWrapper) return;

    if (target.classList.contains("p80-mm__close")) {
      closeMenu();
    } else if (target.classList.contains("p80-mm__next")) {
      const targetPanel = panelsWrapper.querySelector(
        `#${target.dataset.target}`
      );
      const parentPanel = target.closest("ul");
      if (targetPanel && parentPanel) {
        parentPanel.classList.remove("is-active");
        parentPanel.classList.add("is-parent");
        targetPanel.classList.add("is-active");
      }
    } else if (target.classList.contains("p80-mm__back")) {
      const currentPanel = target.closest("ul");
      const parentPanel = panelsWrapper.querySelector(
        `#${target.dataset.parent}`
      );
      if (currentPanel && parentPanel) {
        parentPanel.classList.remove("is-parent");
        parentPanel.classList.add("is-active");
        currentPanel.classList.remove("is-active");
        const firstBtn = parentPanel.querySelector("button");
        if (firstBtn) firstBtn.focus();
      }
    } else if (target.classList.contains("p80-mm__toggle")) {
      target.closest("li.has-submenu").classList.toggle("is-active");
    }
  });

  initMenu();

  window.addEventListener("resize", function () {
    if (window.innerWidth >= 1100) {
      closeMenu();
    }
  });
});
